import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Assignee } from 'types/groupService';
import { AssigneesBlockStyled, AssigneeNameStyled, HideButtonStyled } from './styles';

interface Props {
  agentOfRecord: Assignee | null;
  assigned: Assignee[];
}

/** With AoR: headline is AoR; list is everyone on the roster except AoR. Without AoR: headline is first assignee; list is the remainder of `assigned`. */
function getHeadlineAndRest(
  assigned: Assignee[],
  agentOfRecord: Assignee | null,
): {
  headlineName: string | null;
  rest: Assignee[];
} {
  if (agentOfRecord?.id) {
    return {
      headlineName: agentOfRecord.name,
      rest: assigned.filter((assignee) => assignee.id !== agentOfRecord.id),
    };
  }

  if (assigned.length > 0) {
    return {
      headlineName: assigned[0].name,
      rest: assigned.slice(1),
    };
  }

  return { headlineName: null, rest: [] };
}

const AssigneesBlock: React.FC<Props> = observer(({ assigned, agentOfRecord }) => {
  const [showList, setShowList] = useState(false);

  function onHideShowClick(e: React.MouseEvent<HTMLButtonElement>): void {
    e.stopPropagation();
    setShowList(!showList);
  }

  const { headlineName, rest } = getHeadlineAndRest(assigned, agentOfRecord);

  return (
    <AssigneesBlockStyled>
      {headlineName && <span>{`${headlineName} \n`}</span>}
      {rest.length > 0 && (
        <>
          {showList ? (
            rest.map((assignee) => <AssigneeNameStyled key={assignee.id}>{assignee.name}</AssigneeNameStyled>)
          ) : (
            <span>{`+${rest.length}`}</span>
          )}
          <HideButtonStyled type="button" onClick={onHideShowClick}>
            {showList ? 'hide' : 'view'}
          </HideButtonStyled>
        </>
      )}
    </AssigneesBlockStyled>
  );
});

export default AssigneesBlock;
